import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://admin.1oneplus.net/api';

export const fetchProfile = createAsyncThunk(
    'profile/fetchProfile',
    async (lang, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token');
            if (!token || token === 'social_login_placeholder') {
                return rejectWithValue('You must be logged in with a standard account to access profile.');
            }
            const response = await axios.get(`${BASE_URL}/profile`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                    'lang': lang || 'en',
                },
            });

            if (response.data.status === false) {
                return rejectWithValue(response.data.message || 'Failed to fetch profile');
            }

            return response.data;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data.message || 'Failed to fetch profile');
            }
            return rejectWithValue(error.message || 'Network error');
        }
    }
);

export const updateProfile = createAsyncThunk(
    'profile/updateProfile',
    async ({ formData, lang }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token');
            if (!token || token === 'social_login_placeholder') {
                return rejectWithValue('You must be logged in with a standard account to update profile.');
            }
            const response = await axios.post(`${BASE_URL}/profile/update`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'lang': lang || 'en',
                },
            });

            if (response.data.status === false) {
                return rejectWithValue(response.data.message || 'Failed to update profile');
            }

            return response.data;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data.message || 'Failed to update profile');
            }
            return rejectWithValue(error.message || 'Network error');
        }
    }
);

export const fetchAboutData = createAsyncThunk(
    'profile/fetchAboutData',
    async (lang, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/about-data`, {
                headers: {
                    'Accept': 'application/json',
                    'lang': lang || 'en',
                },
            });

            if (response.data.status === false) {
                return rejectWithValue(response.data.message || 'Failed to fetch about data');
            }

            return response.data;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data.message || 'Failed to fetch about data');
            }
            return rejectWithValue(error.message || 'Network error');
        }
    }
);
